/**
 * Shared sx style constants for mobile editor sheets.
 * Used by the labor, fee, part, and sublet editor sheets.
 */
export const totalCardStyles = {
  display: 'flex',
  justifyContent: 'space-between',
  bgcolor: 'action.hover',
  p: 1.5,
  borderRadius: 1,
} as const;
